// extracted by mini-css-extract-plugin
module.exports = {"icon":"organizationIcon__icon___23G9l"};